import React, {Component} from "react";
import { Timeline } from "antd";
import moment from 'moment-timezone';

/**
 * Displays all the possible schedules a user can view. It contains one, two, seven and nine day schedules a user can view.
 */
class PostedSchedulesList extends Component {

  render() {
    
    return(
      <Timeline style={{ /* marginBottom: -35 */ }}>
        {this.props.listPostedSchedulesArray.map((elem, i) => {
          const { name, startDate } = elem;
          let shortDate = moment(startDate).format('ddd M/D');
          let label;
          
          if (elem.name === 'postedDayOneId') {
            label = `Today ${shortDate}`;
          } else if (elem.name === 'postedTwoDaysToday') {
            label = `Today ${shortDate} 2 days`;
          } else if (elem.name === 'postedTwoDaysTomorrow') {
            label = `${shortDate} 2 days`;
          } else if (name === 'savedMd7') {
            shortDate = moment(startDate, 'M/D').format('ddd M/D');
            label = `Posted 7 days ${shortDate > '-1' ? shortDate : ''}`;
          } else if (name === 'savedMd9') {
            shortDate = moment(startDate, 'M/D').format('ddd M/D');
            label = `Posted 9 days ${shortDate > '-1' ? shortDate : ''}`;
          } else {
            label = shortDate;
          }
          return (
            <Timeline.Item
              key={elem.name}
              color={ (elem.id && elem.id !== -1) ? "blue" : "yellow" }
              // style={{ cursor: (elem.Id && elem.Id > -1) ? "pointer" : null }}
            >
            { (elem.id && elem.id > -1)
            ? <a
                onClick={() => {
                  // eslint-disable-next-line
                  (elem.id && elem.id > -1) ? this.props.handleSelectSchedule(elem) : null
                }}
                style={{ color: 'dodgerblue ' }}
              >
                {label}
              </a>
            : label }
            </Timeline.Item>
          );
        })}

      </Timeline>
    );
  }
}

export default PostedSchedulesList;



// WEBPACK FOOTER //
// ./src/Components/Schedule/PostedSchedulesList.js